import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import shortid from 'shortid';
import THead from './thead';
import Item from './item';
import styles from './list.module.scss';

const List = ({
  data = [],
  cells = [],
  draggable = false,
  onSort,
  onBeforeDragStart,
  onDragStart,
  onDragUpdate,
  onDragEnd,
}) => (
  draggable ? (
    <DragDropContext
      onBeforeDragStart={onBeforeDragStart}
      onDragStart={onDragStart}
      onDragUpdate={onDragUpdate}
      onDragEnd={onDragEnd}
    >
      <table className={styles.table}>
        <THead
          cells={cells}
          styles={styles}
          onSort={onSort}
        />
        {data.map((group, groupIndex) => {
          const [key, isEnabledDrop, ...list] = group;
          return (
            isEnabledDrop ? (
              <Droppable key={shortid.generate()} droppableId={`droppable-[${groupIndex}]`} type={key}>
                {providedDroppable => (
                  <tbody
                    ref={providedDroppable.innerRef}
                    {...providedDroppable.droppableProps}
                  >
                    {list.map(({ item, realIndex }, itemIndex) => (
                      <Draggable key={item.id} draggableId={`draggable-${groupIndex}-[${realIndex}]`} index={itemIndex}>
                        {providedDraggable => (
                          <tr
                            className={styles.row}
                            ref={providedDraggable.innerRef}
                            {...providedDraggable.draggableProps}
                            {...providedDraggable.dragHandleProps}
                          >
                            <Item
                              item={item}
                              index={realIndex}
                              styles={styles}
                              cells={cells}
                            />
                          </tr>
                        )}
                      </Draggable>
                    ))}
                    {providedDroppable.placeholder}
                  </tbody>
                )}
              </Droppable>
            ) : (
              <tbody key={shortid.generate()}>
                {list.map(({ item, realIndex }) => (
                  <tr key={item.id} className={styles.row}>
                    <Item
                      item={item}
                      index={realIndex}
                      styles={styles}
                      cells={cells}
                    />
                  </tr>
                ))}
              </tbody>
            )
          );
        })}
      </table>
    </DragDropContext>
  ) : (
    <table className={styles.table}>
      <THead
        cells={cells}
        styles={styles}
        onSort={onSort}
      />
      <tbody>
        {data.map((item, index) => (
          <tr key={item?.id ?? `row-${index}`} className={styles.row}>
            <Item
              item={item}
              index={index}
              styles={styles}
              cells={cells}
            />
          </tr>
        ))}
      </tbody>
    </table>
  )
);

export default List;
